import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  useToast
} from "@chakra-ui/react";

import { useEffect, useState } from "react";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  initialData?: any;
}

export default function FormModal({
  isOpen,
  onClose,
  onSave,
  initialData
}: Props) {

  const toast = useToast();

  const [form, setForm] = useState({
    procedimento: ""
  });

  useEffect(() => {
    if (initialData) {
      setForm({
        procedimento: initialData.procedimento ?? ""
      });
      return;
    }

    setForm({
      procedimento: ""
    });
  }, [initialData, isOpen]);

  function handleSave() {
    if (!form.procedimento.trim()) {
      toast({ title: "Informe o procedimento", status: "error" });
      return;
    }

    onSave(form);
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />

      <ModalContent>
        <ModalHeader>
          {initialData ? "Editar Procedimento" : "Novo Procedimento"}
        </ModalHeader>

        <ModalBody>
          <VStack spacing={4}>
            <FormControl>
              <FormLabel>Procedimento</FormLabel>
              <Input
                value={form.procedimento}
                onChange={(e) => setForm({ ...form, procedimento: e.target.value })}
              />
            </FormControl>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button mr={3} onClick={onClose}>
            Cancelar
          </Button>

          <Button colorScheme="blue" onClick={handleSave}>
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
